"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.Logo = (_a) => {
    var { logo, header, description, className = '' } = _a, rest = tslib_1.__rest(_a, ["logo", "header", "description", "className"]);
    return (React.createElement("span", Object.assign({ className: `clp-logo ${rest.onClick ? 'c-pointer' : ''} ${className}` }, rest),
        React.createElement("img", { src: logo, alt: description }),
        React.createElement("h3", { className: 'clp-logo__label' },
            header,
            React.createElement("small", { className: 'clp-logo__sub-label' }, description))));
};
//# sourceMappingURL=Logo.js.map